export default __webpack_public_path__ + "static/media/crypto.752f7b8c.mp4";